import { render, staticRenderFns } from "./Examples.vue?vue&type=template&id=3876cc4a&scoped=true"
import script from "./Examples.vue?vue&type=script&lang=js"
export * from "./Examples.vue?vue&type=script&lang=js"
import style0 from "./Examples.vue?vue&type=style&index=0&id=3876cc4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3876cc4a",
  null
  
)

export default component.exports